import BubbleService from "../BubbleService";

class ContractService extends BubbleService {
  constructor() {
    super();
  }
  
  getContract = async (contractCode:any) => {
    const data = await this.postWf('/get_contract_by_code',{contract_code: contractCode});
    return data
  }
  
}

export default ContractService;